var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTomorrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0H25C29.9706 0 34 4.02944 34 9V25C34 29.9706 29.9706 34 25 34H9C4.02944 34 0 29.9706 0 25V9Z",
    fill: "#F4F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.25V12.5M20.75 10.25V12.5M11 14H23",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#697184"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 11.75H21.125C22.1605 11.75 23 12.5895 23 13.625V21.875C23 22.9105 22.1605 23.75 21.125 23.75H12.875C11.8395 23.75 11 22.9105 11 21.875V13.625C11 12.5895 11.8395 11.75 12.875 11.75Z",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#697184"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 18.5L16.25 20L19.25 17",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#697184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomorrowIcon);
export default __webpack_public_path__ + "static/media/tomorrow-icon.ecb14a16eb22aa0cb2dbc669942afecc.svg";
export { ForwardRef as ReactComponent };